import React from "react";

export function DribbbleColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.75 38.5417C43.75 41.4187 41.4187 43.75 38.5417 43.75H11.4583C8.58229 43.75 6.25 41.4187 6.25 38.5417V11.4583C6.25 8.58125 8.58229 6.25 11.4583 6.25H38.5417C41.4187 6.25 43.75 8.58125 43.75 11.4583V38.5417Z"
        fill="#FF4081"
      />
      <path
        d="M34.4387 27.3678C33.7064 27.1376 32.9137 27.5501 32.6825 28.3001C31.8241 31.0688 30.27 33.9449 29.5647 34.1022C29.0366 34.1022 28.2772 33.6542 27.5252 32.6022C29.2689 28.8584 30.1825 24.1584 30.1825 21.0209C30.1825 12.2574 27.97 10.4167 26.1116 10.4167C22.1981 10.4167 22.1533 20.7417 22.1533 20.8459C22.1533 22.0605 22.197 23.1876 22.2793 24.2376C21.7397 24.0407 21.12 23.9053 20.4356 23.9053C16.4147 23.9053 14.5835 27.873 14.5835 31.5584C14.5835 35.0313 16.5325 38.5417 20.8814 38.5417C22.9356 38.5417 24.6668 37.197 26.0637 35.1865C27.3012 36.473 28.597 36.9532 29.5637 36.9532C32.6085 36.9532 34.6241 31.5022 35.3512 29.1553C35.5835 28.4063 35.1741 27.6063 34.4387 27.3678ZM20.8835 35.6917C17.7262 35.6917 17.3835 32.8011 17.3835 31.5574C17.3835 31.3615 17.4189 26.7542 20.4377 26.7542C21.6293 26.7542 22.5439 27.6761 22.5439 27.6761C22.6116 27.749 22.6866 27.8126 22.7647 27.8678C23.1554 29.8511 23.7064 31.4365 24.3439 32.6928C23.2981 34.5032 22.0866 35.6917 20.8835 35.6917ZM25.9387 29.0897C25.3564 27.0792 24.9533 24.3803 24.9533 20.8459C24.9533 17.5897 25.647 14.5251 26.2231 13.4782C26.6647 14.149 27.3845 16.2386 27.3845 21.0209C27.3845 23.5584 26.8231 26.5063 25.9387 29.0897Z"
        fill="white"
      />
    </svg>
  );
}
